import { rgb, PageSizes } from 'pdf-lib'
import genmincho from '../../font/SourceHanSerif-Medium_extracted.otf'
import genmincho_bold from '../../font/SourceHanSerif-Bold_extracted.otf'

import { getDateAfter, getYearMonthDateDisplay } from '../../utils/utils'
import { createPDFDocument, customDrawText } from './pdf_create'
import { getDisplaySize } from '../../utils/Items'
import { postBasePriceSearchInfoListAPI } from '../../http/api/BasePriceAPI'
import { postMarketCalendarSearchNextOpenDateInfoAPI } from '../../http/api/MarketCalendarAPI'

const getPageParameter = (width, height, fonts) => {

  const margin = 10

  const headerHeight = 42
  const tableStart_y = height - margin - headerHeight

  const footerHeight = 30
  const tableEnd_y = margin + footerHeight

  const rowNumber = 40
  const columnNumber = 3

  const rowHeight = (tableStart_y - tableEnd_y) / (rowNumber + 1)
  const columnWidth = (width - 2 * margin) / columnNumber
  
  const nameColumnLeft = 0
  const placeColumnLeft = columnWidth * 0.25
  const sizeColumnLeft = columnWidth * 0.45
  const priceColumnLeft = columnWidth * 0.65
  const orderUnitColumnLeft = columnWidth * 0.8

  return {width,
     height,
    margin,
    headerHeight,
    tableStart_y ,  
    footerHeight ,
    tableEnd_y ,  
    rowNumber ,
    columnNumber ,
    rowHeight ,
    columnWidth ,
    nameColumnLeft ,
    placeColumnLeft ,
    sizeColumnLeft ,
    priceColumnLeft ,
    orderUnitColumnLeft,
    fonts
  }
}



// 価格表　ヘッダ部分作成
const createHeader = (page, title, destination, shippingDate, pageParameter) => {

  const {width, margin, tableStart_y, fonts} = pageParameter

  const shippingDateStr = getYearMonthDateDisplay(shippingDate);
  
  // 表タイトル
  page.drawText('御取引先各位', {
    x: margin,
    y: tableStart_y + 30,
    size: 15,
    font: fonts.mincho_bold_font,
    color: rgb(0, 0, 0),
  })

  page.drawLine({
    start: { x: margin, y: tableStart_y + 25 },
    end: { x: margin + 90, y: tableStart_y + 25},
    thickness : 1,
    color: rgb(0, 0, 0),
    opacity : 1
  })

  page.drawText(destination, {
    x: margin,
    y: tableStart_y + 10,
    size: 12,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })

  page.drawText(title, {
    x: width / 2 - 75,
    y: tableStart_y + 15,
    size: 30,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })

  customDrawText(page,'納品日：', {
    x: width - margin - 200,
    y: tableStart_y + 10,
    size: 15,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })

  customDrawText(page, shippingDateStr, {
    x: width - margin - 140,
    y: tableStart_y + 10,
    size: 18,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })
}

// 価格表の骨格作成
const createTableBones = (page, pageParameter) => {

  const {
    width,
    margin,
    tableStart_y,
    tableEnd_y,
    rowNumber,
    columnNumber,
    rowHeight,
    columnWidth,
    placeColumnLeft,
    sizeColumnLeft,
    priceColumnLeft,
    orderUnitColumnLeft,
    fonts
  } = pageParameter


  // 横罫線
  Array.from(new Array(rowNumber)).forEach((_, index) => {
    page.drawLine({
      start: { x: margin, y: tableStart_y - rowHeight * (index + 1)},
      end: { x: width - margin, y: tableStart_y - rowHeight * (index + 1)},
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })
  })

  page.drawLine({
    start: { x: margin, y: tableStart_y },
    end: { x: width - margin, y: tableStart_y },
    thickness : 2,
    color: rgb(0, 0, 0),
    opacity : 1
  })

  page.drawLine({
    start: { x: margin, y: tableStart_y - rowHeight * (rowNumber + 1) },
    end: { x: width - margin, y: tableStart_y - rowHeight *  (rowNumber + 1) },
    thickness : 2,
    color: rgb(0, 0, 0),
    opacity : 1
  })

  // 縦罫線と表ヘッダ
  Array.from(new Array(columnNumber)).forEach((_, index) => {
    page.drawLine({
      start: { x: margin + columnWidth * index, y: tableStart_y},
      end: { x: margin + columnWidth * index, y: tableEnd_y},
      thickness : 2,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    page.drawText('商品名', {
      x: margin + columnWidth * index + 4,
      y: tableStart_y - rowHeight / 2 - 4,
      size: 10,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })
    
    page.drawLine({
      start: { x: margin + columnWidth * index + placeColumnLeft, y: tableStart_y},
      end: { x: margin + columnWidth * index + placeColumnLeft, y: tableEnd_y},
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    page.drawText('産地', {
      x: margin + columnWidth * index + placeColumnLeft + 4,
      y: tableStart_y - rowHeight / 2 - 4,
      size: 10,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })

    page.drawLine({
      start: { x: margin + columnWidth * index + sizeColumnLeft, y: tableStart_y},
      end: { x: margin + columnWidth * index + sizeColumnLeft, y: tableEnd_y},
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    page.drawText('規格', {
      x: margin + columnWidth * index + sizeColumnLeft + 4,
      y: tableStart_y - rowHeight / 2 - 4,
      size: 10,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })

    page.drawLine({
      start: { x: margin + columnWidth * index + priceColumnLeft, y: tableStart_y},
      end: { x: margin + columnWidth * index + priceColumnLeft, y: tableEnd_y},
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    page.drawText('価格', {
      x: margin + columnWidth * index + priceColumnLeft + 4,
      y: tableStart_y - rowHeight / 2 - 4,
      size: 10,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })

    page.drawLine({
      start: { x: margin + columnWidth * index + orderUnitColumnLeft, y: tableStart_y},
      end: { x: margin + columnWidth * index + orderUnitColumnLeft, y: tableEnd_y},
      thickness : 1,
      color: rgb(0, 0, 0),
      opacity : 1
    })

    page.drawText('注文数', {
      x: margin + columnWidth * index + orderUnitColumnLeft + 4,
      y: tableStart_y - rowHeight / 2 - 4,
      size: 10,
      font: fonts.mincho_font,
      color: rgb(0, 0, 0),
    })
  })

  page.drawLine({
    start: { x: width - margin, y: tableStart_y},
    end: { x: width - margin, y: tableEnd_y},
    thickness : 2,
    color: rgb(0, 0, 0),
    opacity : 1
  })
}

const outputTableData = (page, pageParameter, rowIndex, columnIndex, outputData) => {

  const {
    margin,
    tableStart_y ,  
    rowHeight ,
    columnWidth ,
    placeColumnLeft ,
    sizeColumnLeft ,
    orderUnitColumnLeft,
    fonts
  } = pageParameter;



  const {name, origin, size, price, unit} = outputData;

  const dataStart_x = margin + columnWidth * columnIndex

  const text_y = tableStart_y - rowHeight * (rowIndex + 3 / 2) - 3

  customDrawText(page, name, {
    x: dataStart_x + 4,
    y: text_y,
    size: 8,
    font: fonts.mincho_bold_font,
    color: rgb(0, 0, 0),
  })

  customDrawText(page, origin, {
    x: dataStart_x + placeColumnLeft + 4,
    y: text_y,
    size: 8,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })

  customDrawText(page, size, {
    x: dataStart_x + sizeColumnLeft + 4,
    y: text_y,
    size: 8,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })

  page.drawText(price.toLocaleString(), {
    x: dataStart_x + orderUnitColumnLeft - fonts.mincho_font.widthOfTextAtSize(price.toLocaleString(), 8) - 4,
    y: text_y,
    size: 8,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })

  page.drawText(unit, {
    x: dataStart_x + columnWidth - fonts.mincho_font.widthOfTextAtSize(unit, 8) - 4,
    y: text_y,
    size: 8,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })
}

const createFooter = (page, pageParameter) => {
  const {
    width,
    margin,
    fonts
  } = pageParameter

  page.drawText("丸伊伊那青果(株)", {
    x: width - margin - 340,
    y: 15,
    size: 20,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })

  customDrawText(page, "FAX: (0265) zz-wwww", {
    x: width - margin - 160,
    y: 15,
    size: 15,
    font: fonts.mincho_font,
    color: rgb(0, 0, 0),
  })
}

async function createOrderPDF(title, destination, shippingDate, priceInfoList) {

  
  let vegetablePriceInfoList = priceInfoList.filter((data)=> data.priceDetailTypeId === 1);
  let fruitPriceInfoList = priceInfoList.filter((data)=> data.priceDetailTypeId === 2); 
  let spotPriceInfoList = priceInfoList.filter((data)=> data.priceDetailTypeId === 3); 

  const pdfDoc = await createPDFDocument()
  
  //日本語フォント読込
  const mincho_font = await pdfDoc.embedFont(await (await fetch(genmincho)).arrayBuffer());
  const mincho_bold_font = await pdfDoc.embedFont(await (await fetch(genmincho_bold)).arrayBuffer());

  const [ height, width ] = PageSizes.A4

  //const page = pdfDoc.addPage([width, height])

  const pageParameter = getPageParameter(width, height, {mincho_font, mincho_bold_font});
  let {rowNumber, columnNumber} = pageParameter  
  
  // ページの生成
  let columnCount
    = Math.ceil(vegetablePriceInfoList.length / rowNumber)
    + Math.ceil(fruitPriceInfoList.length / rowNumber)
    + Math.ceil(spotPriceInfoList.length / rowNumber)
  let pageCount = Math.ceil(columnCount / columnNumber);

  let pages = Array.from(new Array(pageCount)).map((_) => {
    let page = pdfDoc.addPage([width, height]);
    createHeader(page, title, destination, shippingDate, pageParameter);
    createTableBones(page, pageParameter);    
    createFooter(page, pageParameter);
    return page;
  });

  var lastName = "";
  var lastOrigin = "";

  var totalDataIndex = 0;

  [vegetablePriceInfoList, fruitPriceInfoList, spotPriceInfoList].forEach((dataList) => {
    if (dataList.length === 0) {
      return;
    }

    totalDataIndex = Math.ceil(totalDataIndex / rowNumber) * rowNumber
    
    dataList.forEach((data, index) => {

      let rowIndex = totalDataIndex % rowNumber;
      let columnIndex = Math.floor(totalDataIndex / rowNumber) % columnNumber;
      let pageIndex = Math.floor(totalDataIndex / (rowNumber * columnNumber));

      if (index % rowNumber === 0) {
        lastName = "";
        lastOrigin = "";
      }

      let outputData = {
        name: (lastName === data.productName ? "" : data.productName),
        origin: (lastName === data.productName && lastOrigin === data.origin ? "" : data.origin),
        size: getDisplaySize(data.rank, data.productClass, data.weight, data.weightUnit, data.packing, data.quantity),
        price: data.price,
        unit: data.orderingUnit
      }

      lastName = data.productName;
      lastOrigin = data.origin;

      outputTableData(pages[pageIndex], pageParameter, rowIndex, columnIndex, outputData);

      totalDataIndex += 1;
    })
  })

  pdfDoc.setCreator("丸伊伊那青果　事務担当");

  // Serialize the PDFDocument to bytes (a Uint8Array)
  return await pdfDoc.save()
}

export async function createBasePricePDF(shippingDate) {

  let res = await postBasePriceSearchInfoListAPI({"basePriceId": 1});
  let basePriceInfoList = res.basePriceInfoList;

  if (!shippingDate) {
    let nextOpenDateRes = await postMarketCalendarSearchNextOpenDateInfoAPI({});
    let nextMarketOpenDate = nextOpenDateRes.nextOpenDateInfo.nextOpenDate;
    shippingDate = nextMarketOpenDate ? new Date(nextMarketOpenDate) : getDateAfter(new Date(), 1);
  }

  return await createOrderPDF(
    "基本価格表",
    "",
    shippingDate,
    basePriceInfoList.map((data)=>({...data, price: data.basePrice}))
  )
}

